export default __webpack_public_path__ + "static/virsat-loading-page-background-6818656a3693199eb4b16af9d317d2e7.jpg";